export default __webpack_public_path__ + "static/media/casaduana_PabloMejia.7d14229f.png";